import { Component, OnInit } from '@angular/core';
import { Event } from '@models';
import { ConditionResult, TaskResults } from '@models/Event/TaskResult.model';
import { CommonShared } from 'app/shared/classes/common';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface SensorConditionsEvalModalParams {
  event: Event;
  conditionResults: ConditionResult[];
  taskResults: TaskResults;
}

@Component({
  standalone: false,
  selector: 'app-sensor-conditions-eval-modal',
  templateUrl: './sensor-conditions-eval-modal.component.html',
  styleUrls: ['./sensor-conditions-eval-modal.component.scss']
})
export class SensorConditionsEvalModalComponent implements OnInit, SensorConditionsEvalModalParams {

  common = new CommonShared();

  modalDragOn: boolean = false;

  event: Event;
  conditionResults: ConditionResult[];
  taskResults: TaskResults;

  // Which reading lists the Details section shows. Defaults match the long-standing view
  // (every reading evaluated) and are remembered per browser.
  showAllReadingsEvaluated: boolean = true;
  showReadingsMeetingCondition: boolean = false;

  private static readonly DETAILS_OPTIONS_STORAGE_KEY = 'TriggerEvalDetailsOptions';

  public evaluateSensorEventResultsCols = [
    {field: 'sensorgroup', header: 'Sensor Group'},
    {field: 'condition', header: 'Condition'},
    {field: 'value', header: 'Value'},
    {field: 'result', header: 'Result'},
    {field: 'logic', header: ''}
  ];

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    //this.conditionResults.forEach(x => x.numericalValue = this.common.setValuePrecisionForKey(x.numericalValue, x.condition.split(' ')[0]))
    this.loadDetailsViewOptions();
  }


  private loadDetailsViewOptions(): void {
    const saved = localStorage.getItem(SensorConditionsEvalModalComponent.DETAILS_OPTIONS_STORAGE_KEY);

    if (!saved) {
      return;
    }

    try {
      const options = JSON.parse(saved);

      if (typeof options?.showAllReadingsEvaluated === 'boolean') {
        this.showAllReadingsEvaluated = options.showAllReadingsEvaluated;
      }

      if (typeof options?.showReadingsMeetingCondition === 'boolean') {
        this.showReadingsMeetingCondition = options.showReadingsMeetingCondition;
      }
    }
    catch {
      localStorage.removeItem(SensorConditionsEvalModalComponent.DETAILS_OPTIONS_STORAGE_KEY);
    }
  }


  saveDetailsViewOptions(): void {
    localStorage.setItem(SensorConditionsEvalModalComponent.DETAILS_OPTIONS_STORAGE_KEY, JSON.stringify({
      showAllReadingsEvaluated: this.showAllReadingsEvaluated,
      showReadingsMeetingCondition: this.showReadingsMeetingCondition
    }));
  }


  hasDetails(conditionResult: ConditionResult): boolean {
    return this.getDetailsSummary(conditionResult) != '';
  }


  // Falls back to the whole details text for conditions the API does not split up (singleCount
  // analysis, which reports a count per sensor rather than individual readings).
  getDetailsSummary(conditionResult: ConditionResult): string {
    const summary = conditionResult.detailsSummary != undefined && conditionResult.detailsSummary != ''
                      ? conditionResult.detailsSummary
                      : conditionResult.stringValue;

    return summary != undefined ? summary : '';
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  isLastConditionResult(id: number): boolean {
    const index = this.conditionResults.findIndex(r => r.id === id);

    return index === this.conditionResults.length - 1;

  }

}
